/* Theme storefront code. Shopify remains authoritative for prices and discounts. */
(() => {
  'use strict';
  const core = window.GodCore;
  class GodBundles extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.variants = JSON.parse(this.querySelector('[data-god-variants]').textContent);
      this.policy = JSON.parse(this.querySelector('[data-god-policy]')?.textContent || 'null') || {};
      this.labels = JSON.parse(this.querySelector('[data-god-labels]')?.textContent || '{}');
      this.changed = () => this.update();
      this.addEventListener('change', this.changed);
      this.info = this.closest('product-info') || this.parentElement;
      this.info.addEventListener('change', this.changed);
      if (typeof subscribe === 'function') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, () => this.update());
      }
      this.update();
      if (this.dataset.preview === 'true') {
        const form = document.getElementById(this.dataset.form);
        form?.addEventListener('submit', event => {
          const quantity = Number(this.querySelector('input:checked')?.value || 1);
          if (quantity > 1) {
            event.preventDefault();
            event.stopImmediatePropagation();
            const note = this.querySelector('.god-bundle-error');
            if (note) { note.hidden = false; note.textContent = 'Design preview only: this bundle does not create a discounted order.'; }
          }
        }, true);
      }
    }
    disconnectedCallback() { this.info?.removeEventListener('change', this.changed); this.unsubscribe?.(); this.started = false; }
    update() {
      const form = document.getElementById(this.dataset.form);
      const variantId = form?.querySelector('[name="id"]')?.value;
      const variant = this.variants.find(v => String(v.id) === String(variantId));
      if (!variant) return;
      const format = cents => new Intl.NumberFormat(this.dataset.locale || 'es', {style: 'currency', currency: this.dataset.currency || 'EUR'}).format(cents / 100);
      for (const card of this.querySelectorAll('.god-bundle')) {
        const radio = card.querySelector('input');
        const quantity = Number(radio.value);
        const total = this.dataset.preview === 'true' ? variant.price * (quantity === 2 ? 1 : quantity === 3 ? 2 : 1) : core.total(variant.price, quantity);
        card.querySelector('[data-total]').textContent = format(total);
        const reference = variant.compare_at_price > variant.price ? variant.compare_at_price : variant.price;
        const original = reference * quantity;
        card.querySelector('[data-original]').textContent = original > total ? format(original) : '';
        card.querySelector('[data-saving]').textContent = `${this.labels.saving || 'Save'} ${format(Math.max(0, original - total))}`;
        const ebookValue = card.querySelector('[data-ebook-value]');
        if (ebookValue) ebookValue.textContent = format(Number(this.labels.ebookValue || 0));
        card.classList.toggle('is-selected', radio.checked);
      }
      const reference = variant.compare_at_price > variant.price ? variant.compare_at_price : variant.price;
      const quantities = this.dataset.ready === 'true' ? (this.dataset.triple === 'true' ? [1,2,3] : [1,2]) : [1];
      const discount = Math.max(...quantities.map(n => Math.floor(100 * (reference*n - core.total(variant.price,n)) / (reference*n))));
      for (const node of document.querySelectorAll('[data-god-announcement]')) {
        node.textContent = (this.dataset.locale || 'en').startsWith('es') ? `SOLO HOY: ${discount}% OFF` : `ONLY TODAY: ${discount}% OFF`;
      }
      let hidden = form?.querySelector('[data-god-quantity]');
      if (form && !hidden) { hidden = document.createElement('input'); hidden.type = 'hidden'; hidden.name = 'quantity'; hidden.dataset.godQuantity = ''; form.append(hidden); }
      const selected = this.querySelector('input:checked');
      if (hidden) hidden.value = selected?.value || '1';
    }
  }
  customElements.define('god-bundles', GodBundles);

  class GodCountdown extends HTMLElement {
    connectedCallback() {
      const titleNode=this.querySelector('[data-seasonal-title]');
      if(titleNode && !titleNode.textContent.trim()) {
        const month=new Date().getMonth()+1;
        const en=!(this.dataset.locale||'en').startsWith('es');
        const names=en ? ['Winter Offer','Pre-Valentine’s Offer','Spring Offer','Spring Offer','Summer Offer','Summer Offer','Summer Offer','Back-to-School Offer','Pre-Halloween Offer','Pre-Halloween Offer','Black Friday Offer','Christmas Offer'] : ['Oferta de invierno','Oferta de San Valentín','Oferta de primavera','Oferta de primavera','Oferta de verano','Oferta de verano','Oferta de verano','Oferta vuelta al cole','Oferta Pre-Halloween','Oferta Pre-Halloween','Oferta Black Friday','Oferta de Navidad'];
        titleNode.textContent=names[month-1];
      }
      if (titleNode) titleNode.textContent = titleNode.textContent.replace(/\bOffer(?:\s+Offer)+\b/gi, 'Offer').replace(/\bends\s+in\s*:?\s*$/i, '').trim();
      const duration = Number(this.dataset.duration) * 1000;
      const demo = this.dataset.demo === 'true';
      const key = `god-demo-clock-v5h:${location.host}`;
      this.deadline = Date.parse(this.dataset.end);
      if (demo) {
        try { this.deadline = Number(localStorage.getItem(key)); } catch (_) {}
        if (!this.deadline || this.deadline <= Date.now()) this.deadline = Date.now() + duration;
      }
      if (!Number.isFinite(this.deadline)) { this.hidden = true; return; }
      const save = () => { if (demo) { try { localStorage.setItem(key, String(this.deadline)); } catch (_) {} } };
      save();
      const tick = () => {
        let remaining = core.remaining(this.deadline, Date.now());
        if (!remaining && demo) { this.deadline = Date.now() + duration; save(); remaining = core.remaining(this.deadline, Date.now()); }
        if (!remaining && !demo) { this.hidden = true; clearInterval(this.timer); return; }
        this.querySelector('[data-time]').textContent = core.clock(remaining);
      };
      tick(); this.timer = setInterval(tick, 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
  }
  customElements.define('god-countdown', GodCountdown);

  class GodLiveViewers extends HTMLElement {
    connectedCallback() {
      this.active = true;
      this.refresh();
      this.timer = setInterval(() => this.refresh(), 30000);
    }
    disconnectedCallback() { this.active = false; clearInterval(this.timer); }
    async refresh() {
      this.controller?.abort();
      this.controller = new AbortController();
      const timeout = setTimeout(() => this.controller.abort(), 5000);
      try {
        const url = new URL(this.dataset.endpoint, location.origin);
        if (url.origin !== location.origin || !url.pathname.startsWith('/apps/')) throw new Error('Invalid app proxy');
        url.searchParams.set('product', this.dataset.product);
        const response = await fetch(url, {credentials:'same-origin', cache:'no-store', signal:this.controller.signal});
        if (!response.ok) throw new Error('Audience unavailable');
        const data = await response.json();
        if (!Number.isSafeInteger(data.viewers) || data.viewers < 0) throw new Error('Invalid audience');
        if (!this.active) return;
        this.querySelector('[data-viewers]').textContent = String(data.viewers);
        this.hidden = data.viewers === 0;
      } catch (_) { this.hidden = true; }
      finally { clearTimeout(timeout); }
    }
  }
  customElements.define('god-live-viewers', GodLiveViewers);

  class GodPreviewVisitors extends HTMLElement {
    connectedCallback() {
      let currentVisitors=9;
      const counter=this.querySelector('#visitor-count');
      const updateVisitors=()=>{
        currentVisitors+=Math.floor(Math.random()*6)-2;
        currentVisitors=Math.max(5,Math.min(35,currentVisitors));
        if(counter)counter.textContent=String(currentVisitors);
      };
      updateVisitors();this.timer=setInterval(updateVisitors,4000);
    }
    disconnectedCallback(){clearInterval(this.timer);}
  }
  customElements.define('god-preview-visitors', GodPreviewVisitors);

  const cfgNode = document.getElementById('god-protection-config');
  const cfg = cfgNode ? JSON.parse(cfgNode.textContent) : null;
  const prefix = window.Shopify?.routes?.root || '/';
  let queue = Promise.resolve();
  let inFlight = 0;
  const read = async url => { const res = await fetch(url, {credentials: 'same-origin'}); if (!res.ok) throw new Error('No se pudo leer el carrito.'); return res.json(); };
  const write = async (path, body) => {
    const res = await fetch(prefix + path, {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(body)});
    const result = await res.json();
    if (!res.ok || result.status) throw new Error(result.description || 'No se pudo actualizar la protección.');
    return result;
  };
  function setBusy(busy) {
    for (const el of document.querySelectorAll('god-protection input, [name="checkout"]')) {
      if (busy) { if (!el.hasAttribute('data-god-was-disabled')) el.dataset.godWasDisabled = String(el.disabled); el.disabled = true; }
      else if (el.hasAttribute('data-god-was-disabled')) { el.disabled = el.dataset.godWasDisabled === 'true'; delete el.dataset.godWasDisabled; }
    }
  }
  async function refresh() {
    const ids = ['cart-drawer', 'cart-icon-bubble'];
    const mainSections = [...document.querySelectorAll('[id^="shopify-section-"]')]
      .filter(el => el.querySelector('cart-items, #main-cart-footer'))
      .map(el => el.id.replace('shopify-section-', ''));
    ids.push(...mainSections);
    const sections = await read(prefix + '?sections=' + ids.join(','));
    const parse = text => new DOMParser().parseFromString(text, 'text/html');
    if (sections['cart-drawer']) {
      const next = parse(sections['cart-drawer']).querySelector('#CartDrawer');
      const current = document.getElementById('CartDrawer');
      if (next && current) { current.innerHTML = next.innerHTML; current.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => current.closest('cart-drawer')?.close()); }
    }
    if (sections['cart-icon-bubble']) { const icon = document.getElementById('cart-icon-bubble'); if (icon) icon.innerHTML = parse(sections['cart-icon-bubble']).querySelector('.shopify-section')?.innerHTML || sections['cart-icon-bubble']; }
    for (const id of mainSections) { const current = document.getElementById('shopify-section-' + id); const next = sections[id] && parse(sections[id]).getElementById('shopify-section-' + id); if (current && next) current.innerHTML = next.innerHTML; }
    document.querySelector('cart-drawer')?.classList.toggle('is-empty', !(await read(prefix + 'cart.js')).item_count);
  }
  function reconcile(optIn, forceRefresh = false) {
    if (!cfg?.productId && !cfg?.ebookVariantId) return Promise.resolve();
    inFlight++; setBusy(true);
    const operation = async () => {
      let cart = await read(prefix + 'cart.js');
      let giftChanged = false;
      if (cfg.ebookVariantId && cfg.mainProductId) {
        const gift=core.ebookPlan(cart,cfg.mainProductId,cfg.ebookProductId,cfg.ebookVariantId);
        giftChanged=Boolean(Object.keys(gift.updates).length || gift.add);
        if(Object.keys(gift.updates).length)await write('cart/update.js',{updates:gift.updates});
        if(gift.add)await write('cart/add.js',{items:[{id:gift.add,quantity:1,properties:{'_god_ebook':'1'}}]});
        cart=await read(prefix+'cart.js');
        const checkGift=core.ebookPlan(cart,cfg.mainProductId,cfg.ebookProductId,cfg.ebookVariantId);
        if(checkGift.add||Object.keys(checkGift.updates).length)throw new Error('No se pudo añadir el ebook gratuito.');
      }
      const selected = optIn === undefined ? cart.items.some(i => String(i.product_id) === String(cfg.productId)) : optIn;
      const plan = core.protectionPlan(cart, cfg.productId, cfg.variants || [], selected, [cfg.ebookProductId], cfg.policy || {});
      const changed = Object.keys(plan.updates).length || plan.add || giftChanged;
      if (Object.keys(plan.updates).length) await write('cart/update.js', {updates: plan.updates});
      if (plan.add) await write('cart/add.js', {items: [{id: plan.add, quantity: 1, properties: {'_god_protection': '1'}}]});
      cart = await read(prefix + 'cart.js');
      const verify = core.protectionPlan(cart, cfg.productId, cfg.variants || [], selected, [cfg.ebookProductId], cfg.policy || {});
      if (verify.add || Object.keys(verify.updates).length) throw new Error('La protección no se ha aplicado correctamente. Inténtalo otra vez.');
      if (changed || forceRefresh) await refresh();
      for (const el of document.querySelectorAll('god-protection input')) el.checked = plan.wanted;
    };
    const next = queue.then(operation);
    queue = next.catch(() => {});
    return next.catch(error => {
      for (const el of document.querySelectorAll('[data-protection-error]')) { el.textContent = error.message; el.hidden = false; }
      throw error;
    }).finally(() => { inFlight--; if (!inFlight) setBusy(false); });
  }
  class GodProtection extends HTMLElement {
    connectedCallback() {
      this.querySelector('input')?.addEventListener('change', event => {
        const wanted = event.target.checked;
        reconcile(wanted).catch(() => { const checkbox = this.querySelector('input'); if (checkbox) checkbox.checked = !wanted; });
      });
    }
  }
  customElements.define('god-protection', GodProtection);
  window.GodStore = {settle: () => reconcile(undefined, true)};
  if (cfg?.productId || cfg?.ebookVariantId) {
    if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.cartUpdate, () => reconcile(undefined, true).catch(() => {}));
    document.addEventListener('cartUpdated', () => reconcile(undefined, true).catch(() => {}));
    reconcile().catch(() => {});
    // Capture before native cart submits; checkout waits for the authoritative cart.
    document.addEventListener('click', event => {
      const button = event.target.closest('[name="checkout"]');
      if (!button || button.dataset.godCheckoutPassed) return;
      event.preventDefault(); event.stopImmediatePropagation();
      reconcile().then(() => {
        const current = (button.id && document.getElementById(button.id)) || document.querySelector('[name="checkout"]');
        if (!current) return;
        current.dataset.godCheckoutPassed = 'true'; current.click(); delete current.dataset.godCheckoutPassed;
      }).catch(() => {});
    }, true);
    document.addEventListener('submit', event => {
      const button = event.submitter;
      if (button?.name !== 'checkout' || button.dataset.godCheckoutPassed) return;
      event.preventDefault(); event.stopImmediatePropagation();
      reconcile().then(() => {
        const current = (button.id && document.getElementById(button.id)) || document.querySelector('[name="checkout"]');
        if (!current?.form) return;
        current.dataset.godCheckoutPassed = 'true'; current.form.requestSubmit(current); delete current.dataset.godCheckoutPassed;
      }).catch(() => {});
    }, true);
  }
})();
